import React from 'react'
import { render } from 'react-dom'
import Cookies from 'universal-cookie'

import './index.css'
import 'antd/dist/antd.css'
import RouteConfig from './router'
import Login from './pages/login'

import registerServiceWorker from './registerServiceWorker'

const cookies = new Cookies()

if (cookies.get('tokenSASSafecash')) {
  render(RouteConfig, document.getElementById('root'))
} else {
  render(<Login />, document.getElementById('root'))
}

registerServiceWorker()




// WEBPACK FOOTER //
// src/index.js